import { PrecisionLogoMain, FacebookIcon, LinkedInIcon } from "assets/website";
import {
  InstagramIcon,
  TwitterIcon,
  WhatsappIcon,
  PhoneCallIcon,
  EnvelopeTwoIcon,
} from "assets/icons";

const EventFooter = () => {
  return (
    <footer className="bg-black text-white py-16 px-6 sm:px-8">
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row md:justify-between gap-12">
        <div className="max-w-[380px]">
          <PrecisionLogoMain className="h-7 w-auto text-white mb-4" />
          <p className="text-[#FCFCFD] mb-8 text-sm leading-relaxed">
            PrecisionMatch helps companies identify truly qualified candidates by automatically scoring, ranking, and assessing applicants.
          </p>
          <div className="flex gap-4 items-center">
            <a
              href="https://www.instagram.com/precisionmatch/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <InstagramIcon className="w-5 h-5 [&_path]:fill-white" />
            </a>
            <a
              href="https://x.com/precisionmatch"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
              className="flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <TwitterIcon className="w-5 h-5 [&_path]:fill-white" />
            </a>
            <a
              href="https://www.facebook.com/share/18MgqCRfxZ/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <FacebookIcon className="w-5 h-5 text-white" />
            </a>
            <a
              href="https://ng.linkedin.com/company/precision-match"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <LinkedInIcon className="w-5 h-5 text-white" />
            </a>
            <a
              href="https://wa.me/2348031301167"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <WhatsappIcon className="w-5 h-5 [&_path]:fill-white" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-semibold mb-6">Contact</h3>
          <ul className="space-y-4">
            <li>
              <a
                href="tel:+2348031301167"
                className="flex items-center gap-3 hover:opacity-80 transition-opacity"
              >
                <PhoneCallIcon className="w-5 h-5 shrink-0" />
                <span className="text-[#FCFCFD] text-sm">+2348031301167</span>
              </a>
            </li>
            <li>
              <a
                href="mailto:contact@precisionmatch.ai"
                className="flex items-center gap-3 hover:opacity-80 transition-opacity"
              >
                <EnvelopeTwoIcon className="w-5 h-5 shrink-0" />
                <span className="text-[#FCFCFD] text-sm">contact@precisionmatch.ai</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export { EventFooter };
